/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/* H3 product-card photos: native touch scrolling, keyboard/arrows, and mouse dragging. */
(() => {
  if (customElements.get('al-card-gallery')) return;
  class ALCardGallery extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.track = this.querySelector('.al-card-gallery__track');
      this.slides = [...this.querySelectorAll('.al-card-gallery__slide')];
      this.prev = this.querySelector('[data-photo-prev]');
      this.next = this.querySelector('[data-photo-next]');
      this.counter = this.querySelector('.al-card-gallery__count');
      if (!this.track || this.slides.length < 2) return;
      this.index = 0;
      this.suppressClick = false;
      this.prev.addEventListener('click', () => this.go(this.index - 1), {signal});
      this.next.addEventListener('click', () => this.go(this.index + 1), {signal});
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, {signal, passive: true});
      this.track.addEventListener('keydown', event => {
        const destinations = {ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1};
        if (!(event.key in destinations)) return;
        event.preventDefault();
        event.stopPropagation();
        this.go(destinations[event.key]);
      }, {signal});
      this.track.addEventListener('dragstart', event => event.preventDefault(), {signal});
      this.track.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.button !== 0) return;
        this.suppressClick = false;
        this.pointer = {id:event.pointerId, type:event.pointerType, x:event.clientX, y:event.clientY, left:this.track.scrollLeft, index:this.index, moved:false};
      }, {signal, passive:true});
      this.track.addEventListener('pointermove', event => {
        const p = this.pointer;
        if (!p || p.id !== event.pointerId) return;
        const dx = event.clientX - p.x, dy = event.clientY - p.y;
        if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) p.moved = true;
        if (p.type !== 'mouse' || !p.moved) return;
        event.preventDefault();
        this.track.setPointerCapture(event.pointerId);
        this.track.setAttribute('data-dragging', '');
        this.track.scrollLeft = p.left - dx;
        this.suppressClick = true;
      }, {signal});
      const finish = event => {
        const p = this.pointer;
        if (!p || p.id !== event.pointerId) return;
        this.suppressClick = p.moved || event.type === 'pointercancel';
        if (p.type === 'mouse' && p.moved) {
          const dx = event.clientX - p.x;
          this.track.removeAttribute('data-dragging');
          this.go(p.index + (Math.abs(dx) > 25 ? (dx < 0 ? 1 : -1) : 0));
        }
        this.pointer = null;
      };
      this.track.addEventListener('pointerup', finish, {signal});
      this.track.addEventListener('pointercancel', finish, {signal});
      this.track.addEventListener('click', event => {
        if (this.suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          this.suppressClick = false;
        }
      }, {signal, capture:true});
      this.resize = new ResizeObserver(() => {
        this.track.scrollTo({left:this.index * this.track.clientWidth, behavior:'instant'});
      });
      this.resize.observe(this.track);
      this.setAttribute('data-ready', '');
      this.update();
    }
    update() {
      if (!this.track.clientWidth) return;
      this.index = Math.min(this.slides.length - 1, Math.max(0, Math.round(this.track.scrollLeft / this.track.clientWidth)));
      this.prev.disabled = this.index === 0;
      this.next.disabled = this.index === this.slides.length - 1;
      this.counter.textContent = `${this.index + 1} / ${this.slides.length}`;
      this.counter.setAttribute('aria-label', `Photo ${this.index + 1} of ${this.slides.length}`);
      this.slides.forEach((slide,index) => { slide.tabIndex = index === this.index ? 0 : -1; });
    }
    go(index) {
      const next = Math.min(this.slides.length - 1, Math.max(0, index));
      this.track.scrollTo({left:next * this.track.clientWidth, behavior:'instant'});
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  }
  customElements.define('al-card-gallery', ALCardGallery);
})();
